import request from '@/utils/httpRequest'

// 获取文创商城列表
export function getculturalcommodityList (query) {
  return request({
    url: '/api/travel/web/culturalCommodity/page',
    method: 'get',
    params: query
  })
}

// 获取详情页
export function getculturalcommodityListdetail (id) {
  return request({
    url: '/api/travel/web/culturalCommodity?id=' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/culturalcommodity/index.js